import React from 'react';

import { Box } from '@wds/box';
import { Typography } from '@wds/typography';

import PropTypes from 'prop-types';
import STRINGS from '../../constants';

const { userEligibilityTab } = STRINGS.accountSettingsPage;

const EligibilityContent = ({ eligibility }) => {
	const showEligibility = eligibility.rendered && eligibility.rendered.length > 0;
	return (
		<Box style={{ width: '100%' }}>
			{showEligibility ? (
				<Box
					id='eligibility-content'
					display='flex'
					flexDirection='column'
					gap={2}
					p={4}
					borderColor='main'
				>
					<div
						dangerouslySetInnerHTML={{ __html: eligibility.rendered }}
					/>
				</Box>
			)
				: (
					<Box
						id='eligibility-content'
						display='flex'
						alignContent='center'
						justifyContent='center'
						p={4}
						borderColor='main'
					>
						<Typography>{userEligibilityTab.eligibilityNotStarted}</Typography>
					</Box>
				)}
		</Box>
	);
};

EligibilityContent.propTypes = { eligibility: PropTypes.object.isRequired };

export default EligibilityContent;
